// Auth0 Configuration
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-5hq2xq7tuevccrde.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'UJ87OsEpQKvLKn7ot6rXtuLij7S1qbPO',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://dev-5hq2xq7tuevccrde.us.auth0.com/api/v2/',
  redirectUri: window.location.origin + '/callback',
  scope: 'openid profile email offline_access read:messages write:messages'
};

export const API_SERVER_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';